import React, { useContext } from "react";
import { NavbarContext } from "../App";
import { Switch } from "react-router-dom";
import { classNames } from "../components/helpers/helpers";
import Navbar from "../components/navbar/Navbar";
import { ProjectBoard } from "../views/projectBoard/ProjectBoard";
import ProjectBoardList from "../views/projectBoardList/ProjectBoardList";
import SalesCloud from "../views/salesCloud/SalesCloud";
import ProtectedRoute from "../components/helpers/ProtectRoute";

const AuthRoutes = () => {
  const { showLargeScreenNav } = useContext(NavbarContext);
  return (
    <>
      <Navbar />
      <div
        className={classNames(
          "page-container",
          showLargeScreenNav ? "move-page" : "unmove-page"
        )}
      >
        <Switch>
          <ProtectedRoute exact path="/">
            <ProjectBoardList />
          </ProtectedRoute>
          <ProtectedRoute exact path="/sales">
            <SalesCloud />
          </ProtectedRoute>
          {/* <ProtectedRoute exact path="/projects/:projectId"> */}
          <ProtectedRoute exact path="/projects/:projectSlug">
            <ProjectBoard />
          </ProtectedRoute>
        </Switch>
      </div>
    </>
  );
};

export default AuthRoutes;
